module.exports = __webpack_public_path__ + "img/save.dbc678ae.svg";